<ng-container *ngIf="isLoading">
  <div class="inputs-container">
    <div class="field margin-bottom">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>
  </div>

  <div class="inputs-container">
    <div class="field margin-bottom">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>

    <div class="field margin-bottom">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>
  </div>

  <div class="inputs-container">
    <div class="field margin-bottom">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>

    <div class="field margin-bottom">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>
  </div>

  <div class="field margin-bottom">
    <div class="field-label-loading-placeholder">
      <app-loading-placeholder></app-loading-placeholder>
    </div>

    <div class="field-loading-placeholder">
      <app-loading-placeholder></app-loading-placeholder>
    </div>
  </div>

  <div class="inputs-container reversed">
    <div class="field">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>

    <div class="field">
      <div class="field-label-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="field-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="!hasError">
    <form [formGroup]="formGroup">
      <div class="inputs-container">
        <div class="field margin-bottom">
          <app-numeric-input
            [formControlName]="'cep'"
            [id]="'cep-input'"
            [name]="'CEP'"
            [placeholder]="'00000-000'"
            [mandatory]="true"
            [inputMask]="'00000-000'"
            [isDisabled]="isLoadingZipCodeAutoFill"
            [autofocus]="isDesktop"
          ></app-numeric-input>

          <div>
            <span class="zip-code-search-text" data-bs-toggle="modal" data-bs-target="#zipCodeSearchModal"
              >Não sei meu CEP</span
            >
          </div>
        </div>

        <div *ngIf="isLoadingZipCodeAutoFill" class="zip-code-auto-fill-loading-container">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <div class="inputs-container">
        <div class="field margin-bottom">
          <app-dropdown-input
            [formControlName]="'tipoLogradouro'"
            [id]="'tipo-logradouro-input'"
            [name]="'Tipo do Logradouro'"
            [mandatory]="true"
            [possibleValues]="addressTypes"
            [isDisabled]="isLoadingZipCodeAutoFill || getFieldDisabledStatus('tipoLogradouro')"
          ></app-dropdown-input>
        </div>

        <div class="field margin-bottom">
          <app-text-input
            [formControlName]="'logradouro'"
            [id]="'logradouro-input'"
            [name]="'Logradouro'"
            [placeholder]="'Digite seu logradouro'"
            [mandatory]="true"
            [isDisabled]="isLoadingZipCodeAutoFill || getFieldDisabledStatus('logradouro')"
          ></app-text-input>
        </div>
      </div>

      <div class="inputs-container">
        <div class="field margin-bottom">
          <app-numeric-input
            [formControlName]="'numero'"
            [id]="'numero-input'"
            [name]="'Número'"
            [placeholder]="'Digite seu número residencial'"
            [mandatory]="true"
            [isDisabled]="isLoadingZipCodeAutoFill || inputCheckNumeroMarked"
          ></app-numeric-input>

          <app-checkbox-input
            [formControlName]="'numeroCheck'"
            [id]="'numero-input'"
            [name]="'Sem Número'"
            [mandatory]="false"
            (click)="clickSemNumero()"
          ></app-checkbox-input>
        </div>

        <div class="field margin-bottom">
          <app-text-input
            [formControlName]="'complemento'"
            [id]="'complemento-input'"
            [name]="'Complemento'"
            [placeholder]="'Bloco, apartamento, etc...'"
            [isDisabled]="isLoadingZipCodeAutoFill"
          ></app-text-input>
        </div>
      </div>

      <div class="field margin-bottom">
        <app-text-input
          [formControlName]="'bairro'"
          [id]="'bairro-input'"
          [name]="'Bairro'"
          [placeholder]="'Digite o nome do seu bairro'"
          [mandatory]="true"
          [isDisabled]="isLoadingZipCodeAutoFill || getFieldDisabledStatus('bairro')"
        ></app-text-input>
      </div>

      <div class="inputs-container reversed">
        <div class="field" [class.margin-bottom]="!isDesktop">
          <app-text-input
            [formControlName]="'municipio'"
            [id]="'municipio-input'"
            [name]="'Município'"
            [placeholder]="'Digite o nome do seu município'"
            [mandatory]="true"
            [isDisabled]="isLoadingZipCodeAutoFill || getFieldDisabledStatus('municipio')"
          ></app-text-input>
        </div>

        <div class="field">
          <app-dropdown-input
            [formControlName]="'estado'"
            [id]="'estado-input'"
            [name]="'Estado'"
            [mandatory]="true"
            [possibleValues]="statesList"
            [isDisabled]="isLoadingZipCodeAutoFill || getFieldDisabledStatus('estado')"
          ></app-dropdown-input>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="hasError">
    <app-error [error]="error"></app-error>
  </ng-container>
</ng-container>

<div class="modal fade" id="zipCodeSearchModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body">
        <div class="zip-code-search-modal-header">
          <h3 class="zip-code-search-modal-title" id="modalLabel">Pesquisar CEP</h3>

          <div class="zip-code-search-modal-close-icon" data-bs-dismiss="modal" aria-label="Close" #closeModal>
            <app-lucide-icon [iconName]="'x'" [size]="20" [color]="'darkGray'"></app-lucide-icon>
          </div>
        </div>

        <div>
          <ng-container *ngIf="!showZipCodeSearchResults">
            <form [formGroup]="zipCodeSearchFormGroup">
              <div class="inputs-container">
                <div class="field margin-bottom">
                  <app-dropdown-input
                    [formControlName]="'estado'"
                    [id]="'estado-input'"
                    [name]="'Estado'"
                    [mandatory]="true"
                    [possibleValues]="statesList"
                    [isDisabled]="isLoadingZipCodeSearch"
                  ></app-dropdown-input>
                </div>

                <div class="field margin-bottom">
                  <app-text-list-input
                    [formControlName]="'localidade'"
                    [id]="locationInputId"
                    [name]="'Localidade'"
                    [mandatory]="true"
                    [possibleValues]="possibleLocations"
                    [isLoading]="isLoadingPossibleLocations"
                    [isDisabled]="isLoadingZipCodeSearch || zipCodeSearchLocationDisabledStatus"
                  ></app-text-list-input>
                </div>
              </div>

              <div class="inputs-container reversed">
                <div class="field" [class.margin-bottom]="!isDesktop">
                  <app-text-input
                    [formControlName]="'logradouro'"
                    [id]="'logradouro-input'"
                    [name]="'Logradouro'"
                    [placeholder]="'Digite seu logradouro'"
                    [mandatory]="true"
                    [isDisabled]="isLoadingZipCodeSearch"
                  ></app-text-input>
                </div>

                <div class="field">
                  <app-numeric-input
                    [formControlName]="'numero'"
                    [id]="'numero-input'"
                    [name]="'Número'"
                    [placeholder]="'Digite seu número residencial'"
                    [mandatory]="true"
                    [isDisabled]="isLoadingZipCodeSearch"
                  ></app-numeric-input>
                </div>
              </div>
            </form>

            <app-form-visualizer [form]="zipCodeSearchFormGroup"></app-form-visualizer>

            <div class="zip-code-search-button-container">
              <app-button
                [text]="'Pesquisar'"
                [fullWidth]="true"
                [isLoading]="isLoadingZipCodeSearch"
                [disabled]="!zipCodeSearchFormGroup.valid"
                (clickEvent)="runZipCodeSearch()"
              ></app-button>
            </div>
          </ng-container>

          <ng-container *ngIf="showZipCodeSearchResults">
            <ng-container *ngIf="zipCodeSearchResults.length">
              <div class="zip-code-search-results-table-container">
                <app-table
                  [columns]="zipCodeSearchResultsColumns"
                  [rows]="zipCodeSearchResults"
                  [allowRowClick]="true"
                  [cardLayoutForMobile]="false"
                  (rowClickEvent)="handleZipCodeSearchResultClick($event)"
                ></app-table>
              </div>
            </ng-container>

            <ng-container *ngIf="!zipCodeSearchResults.length">
              <p class="zip-code-search-no-data-text">Nenhum resultado encontrado para esta busca.</p>
            </ng-container>

            <div class="zip-code-search-button-container">
              <app-button
                [text]="'Voltar'"
                [outline]="true"
                [fullWidth]="true"
                (clickEvent)="backZipCodeSearch()"
              ></app-button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
